import { MdClose, MdOpenInNew } from "react-icons/md";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";
import { useRouter } from "next/navigation";
import Link from "next/link";
import imageCompression from "browser-image-compression";

export default function MemePosterBox({ ...props }) {
  const router = useRouter();
  const { image, texts } = props;

  const [titre, setTitre] = useState(props?.text1?.content || "");
  const [boxType, setBoxType] = useState("image");
  const [nsfw, setNsfw] = useState(false);
  const [spoiler, setSpoiler] = useState(false);
  const [anonyme, setAnonyme] = useState(false);
  const [texte, setTexte] = useState("");
  const [loading, setLoading] = useState(false);
  const [pourcentage, setPourcentage] = useState(0);
  const [listeGroupes, setListeGroupes] = useState([]);
  const [groupe, setGroupe] = useState("meme");
  const [urlmedia, setUrlmedia] = useState("");
  const [fichier, setFichier] = useState(null);
  const { showShareModal, setShowShareModal } = props;
  const [titreTemplate, setTitreTemplate] = useState("");
  const [showTItreTemplate, setShowTitreTemplate] = useState(false);

  useEffect(() => {
    if (props.text1?.content || props.text2?.content) {
      const text1Content = props.text1?.content || "";
      const text2Content = props.text2?.content || "";
      setTitre(`${text1Content}`.trim());
    }
  }, [props.text1, props.text2]);

  useEffect(() => {
    if (image) {
      setFichier(image);
    }
  }, [image]);

  useEffect(() => {
    if (groupe && groupe.length > 0) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("q", groupe);

      const apiUrl = process.env.NEXT_PUBLIC_API_URL + "/api/groupes/boucle";

      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
          // "User-Agent": "Choualbox Next",
        },
      };

      axios.post(apiUrl, bodyFormData, options).then((response) => {
        if (response.data.status == 200) {
          setListeGroupes(Array.from(response.data.data));
        }
      });
    }
  }, [groupe, props.userTk]);

  const poster = async () => {
    setLoading(true);
    var bodyFormData = new FormData();

    bodyFormData.append("token", props.userTk);
    bodyFormData.append("titre", titre);
    if (nsfw) bodyFormData.append("nsfw", 1);
    else bodyFormData.append("nsfw", 0);
    bodyFormData.append("groupe", groupe);
    bodyFormData.append("type", boxType);

    if (spoiler) {
      bodyFormData.append("addspoiler", 1);
    }

    if (anonyme) {
      bodyFormData.append("anonyme", 1);
    }

    if (texte) {
      bodyFormData.append("texte", texte);
    }

    if (urlmedia) {
      bodyFormData.append("url_media", urlmedia);
    }

    if (props.templateId) {
      bodyFormData.append("id_meme", props.templateId);
    }

    if (showTItreTemplate && titreTemplate) {
      bodyFormData.append("create_template", 1);
      bodyFormData.append("titre_template", titreTemplate);
      bodyFormData.append("image_template", props.originalImage);
    }

    if (fichier) {
      // console.log("fichier", fichier);
      const node = props.containerRef?.current;
      if (!node) {
        console.error("Container ref is not available");
        toast("Erreur: Impossible d'accéder à l'élément à capturer", {
          type: "error",
        });
        return;
      }

      try {
        // console.log("Starting image generation" + props.image);

        // Ensure fonts are loaded before generating the image
        await document.fonts.ready;

        const blob = await htmlToImage.toBlob(node, {
          quality: 0.9,
          includeQueryParams: true,
          filter: (node) => {
            const exclusionClasses = ["exclude-me"];
            return !exclusionClasses.some((classname) =>
              node.classList?.contains(classname)
            );
          },
          fontEmbedCSS: true,
          type: "image/jpeg",
          backgroundColor: "#ffffff",
        });

        if (!blob) {
          throw new Error("Failed to generate blob");
        }

        console.log("Image generated successfully, optimizing...");

        // Options d'optimisation
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
          fileType: "image/jpeg",
        };

        // Optimisation de l'image
        const compressedBlob = await imageCompression(blob, options);

        console.log("Image optimized successfully, creating file...");
        const file = new File([compressedBlob], "choualbox-meme.jpg", {
          type: "image/jpeg",
        });
        bodyFormData.append("image", file);
        console.log("File added to form data");
      } catch (error) {
        console.error("Error generating image:", error);
        toast("Erreur lors de la génération de l'image", {
          type: "error",
        });

        setLoading(false);
        return;
      }
    }

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setPourcentage(percentCompleted);
      },
    };

    try {
      const response = await axios.post(
        process.env.NEXT_PUBLIC_API_URL + "/api/boxs/poster",
        bodyFormData,
        options
      );

      if (response.data.status === 200) {
        setTitre("");
        setFichier("");
        setGroupe("");
        setUrlmedia("");
        setTexte("");

        toast(response.data.message, {
          type: "success",
        });

        router.push("/" + response.data.permalink);
      } else {
        toast(response.data.message, {
          type: "error",
        });
      }
    } catch (error) {
      if (error.response) {
        toast("Le serveur a renvoyé une erreur (!200)", {
          type: "error",
        });
      } else if (error.request) {
        toast("Le serveur n'a pas renvoyé de réponse (pas de réponse)", {
          type: "error",
        });
      } else {
        toast("Erreur de chargement", {
          type: "error",
        });
      }
    } finally {
      setPourcentage(0);
      setLoading(false);
    }
  };

  return (
    <dialog
      id="share_modal"
      className={`modal ${showShareModal ? "modal-open" : ""}`}
    >
      <div className="modal-box">
        <button
          className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          onClick={() => setShowShareModal(false)}
        >
          <MdClose className="w-4 h-4" />
        </button>
        <h3 className="font-bold text-lg mb-4">Poster une box</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            poster();
          }}
        >
          <div className="flex flex-col gap-2">
            <fieldset className="fieldset">
              <legend className="fieldset-legend">Titre</legend>

              <input
                type="text"
                placeholder="Titre"
                onChange={(e) => setTitre(e.target.value)}
                className="input input-bordered w-full"
                value={titre}
              />
            </fieldset>
            <fieldset className="fieldset">
              <legend className="fieldset-legend">Groupe</legend>
              <input
                type="text"
                role="combobox"
                aria-controls=""
                placeholder="Groupe"
                className="input input-bordered w-full"
                onChange={(e) => {
                  setGroupe(e.target.value);
                }}
                value={groupe}
                list="groupes"
              />
            </fieldset>
            {listeGroupes && listeGroupes.length > 0 ? (
              <datalist id="groupes" role="listbox">
                {listeGroupes.map((grp, index) => {
                  if (index >= 10) {
                    return;
                  }
                  return <option key={grp.permalink} value={grp.permalink} />;
                })}
              </datalist>
            ) : null}
          </div>
          <div className="flex flex-col sm:flex-row mt-2">
            <div className="flex gap-1">
              <button
                type="button"
                onClick={() => setNsfw(!nsfw)}
                className={`btn btn-sm no-animation ${
                  nsfw && " btn-secondary "
                }}`}
              >
                + NSFW
              </button>
              <button
                type="button"
                onClick={() => setSpoiler(!spoiler)}
                className={`btn btn-sm no-animation ${
                  spoiler && " btn-secondary "
                }}`}
              >
                {" "}
                + Spoiler
              </button>
            </div>
          </div>
          {/* si ce n'est pas un template on propose d'en créer un */}
          {!props.templateId && (
            <>
              <fieldset className="fieldset bg-base-100 border-base-300 rounded-box w-full border p-4 mt-4">
                <legend className="fieldset-legend">Template</legend>

                <label className="label justify-start">
                  <input
                    type="checkbox"
                    className="checkbox mr-2"
                    checked={showTItreTemplate}
                    onChange={() => setShowTitreTemplate(!showTItreTemplate)}
                  />
                  Créer un template avec cette image
                </label>
                {showTItreTemplate && (
                  <input
                    type="text"
                    placeholder="Nom du meme"
                    onChange={(e) => setTitreTemplate(e.target.value)}
                    className="input input-bordered w-full mb-2"
                    value={titreTemplate}
                    required
                  />
                )}
              </fieldset>
            </>
          )}
          <div className="modal-action">
            {/* <button
              type="button"
              className="btn"
              onClick={() => setShowShareModal(false)}
            >
              Annuler
            </button> */}
            <button
              className="btn btn-primary"
              type="submit"
              disabled={!image || loading || !titre || !groupe}
            >
              {loading && <div className="loading loading-spinner mr-1" />}
              {loading ? "Posting..." : "Poster"}
            </button>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={() => setShowShareModal(false)}>close</button>
      </form>
    </dialog>
  );
}
